module.exports = __webpack_public_path__ + "static/fonts/icomoon.0f361181.woff";